module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAnCAYAAACBvSFyAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAErSURBVHgBzZi7DoMwDEVvOzEydmTsyMjosWPHjv3/n6COSCQaERqCH7UUIV7yUW5iOwb+wC5wtHmeB76QCwQ774JzHlO4N4dgAIrOu/TMDCJO/ZNHn79Th2DnfXQ+lL5Rg8h13zMVCAaYIkBX870oRNT9weN25D8RiBrd1SCi7hOyLWcGwQAjlqlvdt4MkUItGqf+FETUnXiMELafEFK6N0MwwB2L7j0U7VJwPkBY92qII6FWBWIrxZpB7KVYK7t6Ok+2liNtQ3OofGGqBaRqiAymOSuKQKxgwowQPILVBgzBK2xnIH4JrADzhqBEZ4saggCMVHlHOGGShS6hcb1Il/xN9YfW4efQetE8BlZLZHUgJuzAWLYGihJ5NUnGNYxXu+hLIu/GWYB5fQAmXIERm8+ADwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/header/left-arrow.png
// module id = 95
// module chunks = 0